import React, { useEffect, useState, useRef } from 'react';
import styled from "styled-components";

/* Search.tsx는 검색창을 보여주고 검색어를 입력받는 컴포넌트 */

interface SearchProps {
    searchedTerm: string;
    onSearchedTerm: React.Dispatch<React.SetStateAction<string>>;
    styleFor: string;
    placeholder: string;
}

const Body = styled.div<{$styleFor: string}>`
    display: flex;
    align-items: center;
    position: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? 'absolute' : 'relative'};
    left: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? '50%' : 'auto'};
    transform: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? 'translateX(-50%)' : 'none'};
    width: ${({$styleFor}) => 
        $styleFor === process.env.REACT_APP_STYLE_HOME_SEARCH ? '300px' : '100%'};
`;

const SearchBox = styled.input`
  width: 100%;
  max-width: 700px;
  height: 2.5rem;
  padding: 0 1rem 0 1rem; /* 아이콘 자리를 위해 왼쪽 여백 */
  border-radius: 2rem;
  border: 1px solid ${props => props.theme.SEARCH.BORDER};
  background: ${props => props.theme.SEARCH.BACKGROUND};
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px ${props => props.theme.SEARCH.SHADOW};
  color: ${props => props.theme.CONTENT.TITLE_COLOR};

  &:focus {
    outline: none;
    width: 110%; /* 포커스 시 살짝 길어지는 효과 */
    border-color: ${props => props.theme.SEARCH.FOCUS.BORDER};
    box-shadow: 0 0 0 2px ${props => props.theme.SEARCH.FOCUS.SHADOW};
  }

    &::placeholder {
        color: ${props => props.theme.CONTENT.TITLE_COLOR};
    }
`;

function Search({searchedTerm, onSearchedTerm, styleFor, placeholder}: SearchProps) {
    const [searchTerm, setSearchTerm] = useState(searchedTerm || "");
    
    // 부모의 searchedTerm이 바뀌었을 때 대비 동기화 처
    useEffect(() => {
	    if (searchedTerm !== undefined) {
		    setSearchTerm(searchedTerm);
	    }
    }, [searchedTerm]);

    // 한글 조합 중인지 체크하는 flag
    const isComposing = useRef(false);

    const onCompositionStart = () => {
	    isComposing.current = true;
    }

    const onCompositionEnd = (e:React.CompositionEvent<HTMLInputElement>) => {
	    isComposing.current = false;

	    // 조합 끝난 최종 결과를 상태에 반영 
	    setSearchTerm(e.target.value);
    }

    const onChange = (e:React.ChangeEvent<HTMLInputElement>) => {
	setSearchTerm(e.target.value);
    };

    // 입력한 값을 부모에게 전달하여 동기화
    useEffect(() => {
        onSearchedTerm(searchTerm);
    }, [searchTerm]);

    return <Body $styleFor={styleFor}>
        <SearchBox
		value={searchTerm}	
		onChange={onChange}
	       	onCompositionStart={onCompositionStart}
		onCompositionEnd={onCompositionEnd}	
		placeholder={placeholder}
	/>
    </Body>;
}

export default Search;
